/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxNC4xNjY4TDkuMTY2NjcgMTAuMDAwMkw1IDUuODMzNU0xMC44MzMzIDE0LjE2NjhMMTUgMTAuMDAwMkwxMC44MzMzIDUuODMzNSIgc3Ryb2tlPSIjMTgxRDI3IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";